import type { ReactNode } from "react"
import { z } from "zod"

import type { PermissionActionType } from "@/constants/permissions"

// Define the schema for the navigation route structure using Zod
export const RouteNavObjectSchema: z.ZodType<RouteNavObject> = z.object({
  pathname: z.string(),
  label: z.string().optional(),
  children: z.array(z.lazy(() => RouteNavObjectSchema)).optional(),
  icon: z.any().optional(),
})

// Define the type for the navigation route structure
export interface RouteNavObject {
  pathname: string
  label?: string
  permissions?: PermissionActionType[]
  children?: RouteNavObject[]
  icon?: ReactNode
}

export interface RouteObject {
  pathname: string
  children?: RouteObject[]
}

export type LabelMapping = Record<string, string>
export type PermissionMapping = Record<string, PermissionActionType[]>

export type IconMapping = Record<string, ReactNode>
